:host {
	display: inline-block;
	vertical-align: text-top;
}

.zds-icon {
	display: block;

	svg {
		display: block;
		fill: currentcolor;
		height: auto;
		width: auto;
	}

	// Set the icon's dimensions to em to make sure the icon size adheres to the given font-size
	&:not(&--sizing-type-width) {
		height: 1em;

		svg {
			height: 100%;
		}
	}

	&:not(&--sizing-type-height) {
		width: 1em;

		svg {
			width: 100%;
		}
	}
}

.zds-icon__missing {
	background-color: currentcolor;
	height: 100%;
	width: 100%;
}
